export const requestCycle = {
    success: 'success',
    pending: 'pending',
    failed: 'failed',
}
